import { register } from 'ol/proj/proj4';
import proj4 from 'proj4';
export var a11yClick = event => {
  if (event.type === 'click') {
    return true;
  } else if (event.type === 'keypress') {
    if (event.code === '32' || event.code === '13') {
      return true;
    }
  }

  return false;
};
/**
 * Registers additional projections with the proj4 projection library.
 * @param {string} epsgCode EPSG code of the projection information.
 * @param {string} projection Proj4 projection string for transformations.
 */

export var registerProjection = (epsgCode, projection) => {
  if (!epsgCode || !projection) return;
  proj4.defs(epsgCode, projection);
  register(proj4);
};
export var visibleAtResolution = (layer, resolution) => {
  return layer.getVisible() && resolution >= layer.getMinResolution() && resolution < layer.getMaxResolution();
};
export var getOptions = props => {
  var options = {};

  for (var key in props) {
    if (key !== 'children' && typeof props[key] !== 'undefined' && //exclude undefined ones
    !key.match(/^on[A-Z]/) || //exclude events
    props[key] === 0) {
      options[key] = props[key];
    }
  }

  return options;
};

var getPropsKey = eventName => {
  return 'on' + eventName.replace(/(:[a-z])/g, $1 => $1.toUpperCase()).replace(/^[a-z]/, $1 => $1.toUpperCase()).replace(':', '');
};

export var getEvents = function getEvents() {
  var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var prop2EventMap = {};

  for (var key in events) {
    prop2EventMap[getPropsKey(key)] = key;
  }

  var ret = {};

  for (var propName in props) {
    var eventName = prop2EventMap[propName];
    var prop = props[propName];

    if (typeof prop !== 'undefined' && propName.match(/^on[A-Z]/) && eventName) {
      ret[eventName] = prop;
    }
  }

  return ret;
};
export var createImgWithClassName = (src, className) => {
  var el = document.createElement('img');
  if (className) el.className = className;
  el.src = src;
  return el;
};